module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.08525ec9.jpg";